import { createFileRoute } from '@tanstack/react-router'
import SettingsEnvironmentsPage from '@/components/pages/Settings/team/SettingsEnvironmentsPage/SettingsEnvironmentsPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/environments')({
  component: EnvironmentsSettingsRoute,
})

function EnvironmentsSettingsRoute() {
  return <SettingsEnvironmentsPage />
}
